// extracted by mini-css-extract-plugin
export var actionText = "_kv-4";
export var container = "_kv-0";
export var leftSection = "_kv-1";
export var rightSection = "_kv-2";
export var settingsButton = "_kv-6";
export var settingsIcon = "_kv-7";
export var shortcut = "_kv-5";
export var shortcutGroup = "_kv-3";